import gql from 'graphql-tag';

export default gql`
mutation SendTextMessage($storeNumber: String!, $phoneNumber: String!){
  sendStoreDirections(storeNumber: $storeNumber, phoneNumber: $phoneNumber) {
    success
  }
}
`;
